<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <signup-card>
                <h2 class="title text-center" slot="title">Register</h2>
                <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto"
                        slot="content-right">
                    <form class="form-horizontal" action="" method="post" v-on:submit.prevent="onSubmit">
                        <md-field class="md-form-group" v-for="item in inputs" :key="item.name">
                            <md-icon>{{ item.icon }}</md-icon>
                            <label>{{ item.name }}</label>
                            <md-input v-model="item.value" :type="item.type"></md-input>
                        </md-field>
                        <div class="button-container">
                            <md-button href type="submit" class="md-success md-round mt-4" slot="footer"
                            >Get Started</md-button>
                        </div>
                    </form>
                </div>
            </signup-card>
        </div>
    </div>
</template>
<script>
import { SignupCard } from "@/components";
export default {
    components: {
        SignupCard
    },

    created () {
        this.checkedSignedIn()
    },
    updated () {
        this.checkedSignedIn()
    },

    methods: {
        onSubmit: function () {
            const user = { email: this.inputs[0].value, password: this.inputs[1].value };
            this
                .$http
                .plain
                .post('/signup', user)
                .then(response => this.signupSuccessful(response))
                .catch(error => this.signupFailed(error))
        },
        signupSuccessful (response) {
            if (!response.data.csrf) {
                this.signupFailed(response);
                return
            }

            localStorage.csrf = response.data.csrf;
            localStorage.signedIn = true;
            this.error = '';
            this.$router.replace('/tags')
        },
        signupFailed (error) {
            this.error = (error.response && error.response.data && error.response.data.error) || 'Something went wrong';
            delete localStorage.csrf;
            delete localStorage.signedIn
        },
        checkedSignedIn () {
            if (localStorage.signedIn) {
                this.$router.replace('/tags')
            }
        }
    },
    data() {
        return {
            boolean: false,
            inputs: [
                {
                    icon: "email",
                    name: "Email...",
                    value: "",
                    type: "email"
                },

                {
                    icon: "lock_outline",
                    name: "Password..",
                    value: "",
                    type: "password"
                }
            ]
        };
    },

};
</script>
<style></style>
